import { render } from "./ScrollUpButton.vue?vue&type=template&id=bee8c18e&scoped=true"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js"

import "./ScrollUpButton.vue?vue&type=style&index=0&id=bee8c18e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee8c18e"]])

export default __exports__